import { render } from "./GamePage.vue?vue&type=template&id=1265ddd7&scoped=true"
import script from "./GamePage.vue?vue&type=script&lang=js"
export * from "./GamePage.vue?vue&type=script&lang=js"

import "./GamePage.vue?vue&type=style&index=0&id=1265ddd7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1265ddd7"]])

export default __exports__